module.exports = "<p>\r\n  repor-logs works!\r\n</p>\r\n"